import styled from "styled-components";
export const BreadcrumbStyled = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  .breadcrumb_item {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
  .home_page_button {
    padding: 0;
    background: none;
    color: ${({ theme }) => theme.COLORS.BLACK_6};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
  }
  .secondary_page_button {
    background: none;
    color: ${({ theme }) => theme.COLORS.BLACK_6};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
  }
`;
